// poly.pizza — searchable library of CC0/CC-BY low-poly models (GLB).
// Goes through the same-origin Pages Function proxy (key server-side).

// Always the same-origin Pages Function: the key lives server-side only. In
// dev, Vite proxies /api to the live functions (see vite.config.ts), so no
// provider key is ever read by client code (and none can be inlined).
const BASE = '/api/polypizza';

function headers(): Record<string, string> {
  return {};
}

export interface PolyModel {
  id: string;
  title: string;
  thumbnail: string;
  downloadUrl: string;
  creator: string;
  licence: string;
  triCount?: number;
}

export async function searchModels(keyword: string, page = 0, limit = 24): Promise<{ models: PolyModel[]; total: number }> {
  const q = encodeURIComponent(keyword.trim() || 'furniture');
  const res = await fetch(`${BASE}/search/${q}?Limit=${limit}&Page=${page}`, { headers: headers() });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Model search failed: ${res.status}`);
  }
  const data = await res.json();
  const results = data.results || [];
  return {
    total: data.total ?? results.length,
    models: results.map((r: any) => ({
      id: String(r.ID ?? r.id ?? ''),
      title: r.Title || r.title || 'Model',
      thumbnail: r.Thumbnail || r.thumbnail || '',
      downloadUrl: r.Download || r.download || '',
      creator: r.Creator?.Username || r.creator || 'Unknown',
      licence: String(r.Licence ?? r.licence ?? ''),
      triCount: r.TriCount ?? r.triCount,
    })).filter((m: PolyModel) => m.downloadUrl),
  };
}

/** Fetch the GLB binary (proxied in production — files lack CORS headers). */
export async function fetchModelBlob(downloadUrl: string): Promise<Blob> {
  const url = `/api/polypizza/download?url=${encodeURIComponent(downloadUrl)}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Model download failed: ${res.status}`);
  return res.blob();
}
